import styled from 'styled-components';

export const Container = styled.div`
  height: 96vh; // 100 - altura do header (4px)
`;
